/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { RichTextComponent } from '@msdyn365-commerce/core';
import { IPageFooterViewProps } from './page-footer';

export default (props: IPageFooterViewProps) => {
    const { buttonText, title, description, buttonLink, hide } = props;
    if (hide) {
        return null;
    }
    return (
        <div
            data-content-type='row'
            data-appearance='contained'
            data-element='main'
            style={{
                justifyContent: 'flex-start',
                display: 'flex',
                flexDirection: 'column',
                backgroundPosition: 'left top',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundAttachment: 'scroll',
                borderStyle: 'none',
                borderWidth: '1px',
                borderRadius: '0px',
                margin: '0px 0px 10px',
                padding: '10px'
            }}
        >
            <h2
                className='Find-Your-Sample-Title'
                data-content-type='heading'
                data-appearance='default'
                data-element='main'
                style={{
                    textAlign: 'center',
                    borderStyle: 'none',
                    borderWidth: '1px',
                    borderRadius: '0px'
                }}
            >
                {title}
            </h2>
            <div
                data-content-type='text'
                data-appearance='default'
                data-element='main'
                style={{
                    borderStyle: 'none',
                    borderWidth: '1px',
                    borderRadius: '0px',
                    margin: '0px',
                    padding: '0px'
                }}
            >
                <RichTextComponent text={description} />
            </div>
            <div
                data-content-type='buttons'
                data-appearance='inline'
                data-same-width='false'
                data-element='main'
                style={{
                    textAlign: 'center',
                    borderStyle: 'none',
                    borderWidth: '1px',
                    borderRadius: '0px',
                    margin: '0px',
                    padding: '10px 10px 0px'
                }}
            >
                {buttonText ? (
                    <div data-content-type='button-item' data-appearance='default' data-element='main' style={{ display: 'inline-block' }}>
                        <a
                            target=''
                            data-link-type='default'
                            data-element='link'
                            href={buttonLink?.destinationUrl}
                            className='pagebuilder-button-primary '
                            style={{ textAlign: 'center' }}
                        >
                            <span data-element='link_text'>{buttonText}</span>
                        </a>
                    </div>
                ) : null}
            </div>
        </div>
    );
};
